import { useCurrentUser } from '../../../shared/features/session/components/CurrentUserProvider';

/** The customer picker reads the customer list, which needs `customer.view` and not `fleet.view`; without it the filter would only fail. UX only: the server decides. */
export function useCanFilterByCustomer(): boolean {
  const { state } = useCurrentUser();
  return state.status === 'authenticated' && state.user.permissions.includes('customer.view');
}
